import { setup } from 'axios-cache-adapter';
import localforage from 'localforage';
import memoryDriver from 'localforage-memoryStorageDriver';

localforage.defineDriver(memoryDriver);

/**
 *
 * Criar uma instancia de forage
 *
 * @param {string} [name='static']
 * @return {*}
 */
const getLocalForageInstance = (name = 'static') => {
  return localforage.createInstance({
    driver: [
      localforage.INDEXEDDB,
      localforage.LOCALSTORAGE,
      memoryDriver._driver
    ],
    name: name
  });
};

/**
 * Define o adaptador de cache por minutos (default: 15) para instâncias axios não privadas
 *
 * @function
 * @param {number} [min=15]
 * @param {string} [name='static']
 * @param {Array} [excludeMethods=['post', 'patch', 'put', 'delete']]
 * @return {{maxAge: number, exclude: any, debug: boolean, store: any}}
}}
 */
export const getCacheConfig = (min = 15, name = 'static', excludeMethods = ['post', 'patch', 'put', 'delete']) => {
  return {
    maxAge: min * 60 * 1000,
    exclude: {
      methods: excludeMethods
    },
    debug: false,
    store: getLocalForageInstance(name)
  };
};

export const setupApi = setup;
